<template>
  <div class="formula">
    <prism language="javascript">{{ code }}</prism>
  </div>
</template>

<script>
import 'prismjs'
import 'prism-themes/themes/prism-duotone-dark.css'
import code from '!raw-loader!../common/formula'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      code
    }
  },
  components: {
    Prism
  }
}
</script>

<style lang="postcss" scoped>
.formula {
  margin-bottom: 140px;
  code {
    font-size: 12px;
  }
}
</style>
